import { defineComponent as p, reactive as c, watch as d, computed as f, createElementBlock as h, openBlock as u, withModifiers as m, normalizeClass as k, createVNode as w } from "vue";
import _ from "./TessText.js";
import { c as y } from "./linkHelper-si1dIzqz.js";
/* empty css                                                                       */
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const T = ["href"], g = /* @__PURE__ */ p({
  __name: "TessHyperLink",
  props: {
    text: {},
    size: {},
    weight: {},
    width: {},
    tooltipTheme: {},
    showTooltip: { type: Boolean },
    type: { default: "core" },
    config: { default: () => ({}) },
    disabled: { type: Boolean, default: !1 },
    url: { default: "" },
    replaceCurrent: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = i, t = c({
      link: "",
      hasError: !1
    }), n = (r) => {
      try {
        return new URL(r), !0;
      } catch (o) {
        return console.error("Invalid URL:", { error: o, url: r }), !1;
      }
    }, s = () => {
      if (n(e.url)) {
        t.link = e.url;
        return;
      } else {
        const r = y({
          type: e.type,
          config: e.config
        });
        t.link = r.url || "", t.hasError = r.hasError;
      }
    }, a = () => {
      e.disabled || t.hasError || (e.replaceCurrent ? window.location.replace(t.link) : window.open(t.link, "_blank"));
    };
    d(() => e, s, { immediate: !0, deep: !0 });
    const l = f(() => e.text || t.link);
    return (r, o) => (u(), h("a", {
      class: k(["tess-hyperlink-wrapper", { disabled: e.disabled, error: t.hasError }]),
      href: t.link,
      onClick: m(a, ["prevent"])
    }, [
      w(_, {
        text: l.value,
        size: e.size,
        weight: e.weight,
        width: e.width,
        tooltipTheme: t.hasError ? "warning" : void 0
      }, null, 8, ["text", "size", "weight", "width", "tooltipTheme"])
    ], 10, T));
  }
}), z = /* @__PURE__ */ x(g, [["__scopeId", "data-v-005650aa"]]);
export {
  z as default
};
